//--------------------------------------------------
// imported classes
//--------------------------------------------------
const Invitation = require('./Invitation')
const ClassFunc = require('../../util/ClassFunc')

/**
 * The Player class works as the player translator.
 */
const tbs_model_to_Staff = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Invitation, arguments);
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_to_Staff.prototype = {
    'role-option-1': '超级管理员',
    'role-option-2': '机构管理',
    'role-option-3': '机构财务',
    'role-option-4': '赛事执行',
    'role-option-5': '赛场执行',
    'role-option-6': '机构运营',
    'role-option-9': '课程管理',
    'staff-empty-hint': '暂无工作人员，新建人员',
    'staff-name-required': '请填写姓名',
    'staff-name-label': '姓名',
    'staff-name-placeholder': '姓名',
    'staff-super-admin-label': '超级管理员',
    'staff-remark-label': '备注（可选）',
    'staff-remark': '备注',
    'staff-remark-placeholder': '备注说明内容',
    'staff-role-label': '操作权限',
    'staff-role-required': '请选择操作权限',
    'delete-staff': '删除工作人员',
    'delete-staff-confirm-message': '确认删除该工作人员，无法进行还原',
    'match-grant': '添加权限',
    'match-revoke': '移除权限',
    'match-permission': '赛事权限',
    'staff-match-empty-hint': '暂无赛事权限，添加权限',
}

//--------------------------------------------------
// extends the Invitation
//--------------------------------------------------
ClassFunc.extend(tbs_model_to_Staff, Invitation);

module.exports = tbs_model_to_Staff